export const PROMO_URL = 'https://firework.tv?utm_source=website&utm_content=widget&utm_campaign=madeinfirework';
export var ScrollDirectionEnum;
(function (ScrollDirectionEnum) {
    ScrollDirectionEnum["LEFT"] = "scroll-left";
    ScrollDirectionEnum["RIGHT"] = "scroll-right";
})(ScrollDirectionEnum || (ScrollDirectionEnum = {}));
export const AD_GRID_BREAKPOINT = 728;
export const AD_ROW_BREAKPOINT = 728;
export const AD_GRID_MOBILE_SPAN = 2;
export const columnsForWidth = (width) => {
    if (width >= 960) {
        return 5;
    }
    else if (width >= 640) {
        return 4;
    }
    else if (width >= 480) {
        return 3;
    }
    return 2;
};
